import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

export default class CustomFieldAddFormProto extends BaseComponent {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this._bind('onSubmit');

        this.type = null; // should be overridden

        const showScope = !props.ignoreScope;

        this.initFormData = {
            name:           '',
            scope:          this.props.scope,
            description:    '',
            access:         gd.const.customFields.access.EVERYONE
        };

        if (this.props.customField) {
            this.initFormData = {
                name:   this.props.customField.name,
                scope:  this.props.customField.params.scope,
                access: this.props.customField.access
            }
        }

        const existingCustomFields = gd.session.customFields.filterByCompany(gd.companyId);

        this.formStructure = {
            fields: {
                name:           { type: 'input', isRequired: true, label: 'Name',
                    validator: (val) => {
                        let res = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'No valid characters found';
                        } else {
                            const cf = _.find(existingCustomFields.models, cf => cf.name === val.trim());
                            if (!cf || (this.props.customField && cf.id === this.props.customField.id)) res = true;
                            else res = 'Field with this name already exists';
                        }
                        return res;
                    }
                },
                // scope:          { type: 'select', isRequired: false, label: 'Scope',
                //     validator: (val) => {
                //         return !val || val.length === 0 ? 'No scope selected' : true;
                //     }
                // },
                description:    { type: 'input', isRequired: false, label: 'Description'},
                access:         { type: 'select', isRequired: true, label: 'Access'},
                isRequired:     { type: 'boolean', isRequired: false, label: 'Is required'},
            },
            onSubmit: this.onSubmit
        };

        if (showScope) {
            this.formStructure.fields['scope'] = {
                type: 'select',
                isRequired: false,
                label: 'Scope',
                validator: (val) => {
                    return !val || val.length === 0 ? 'No scope selected' : true;
                }
            }
        }

        // this.form = new FormManager(formStructure, initFormData); that should happen in field!
    }

    onSubmit(result) {
        console.error("This method should be overridden");
    }
}
